module.exports = __webpack_public_path__ + "static/media/guadalupe_dorada.2e37d663.png";